import React, { useEffect, useState } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { BtnAcao, BtnAcaoLink, Visualizar } from '../../../../components/Acoes'
import { Link } from 'react-router-dom';
import { get } from '../../../../util/AcessoApi';
import { mensagens, useInterval } from '../../../../util/Utilitarios';
import ChamarPainel from './Cadastro';
import { getUsuario } from '../../../../util/Configuracoes';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { mostrarToast } from '../../../../components/Toasts';

const Consulta = props => {
    const [agendamentos, setAgendamentos] = useState([]);
    const [abrirModalPainel, setAbrirModalPainel] = useState(false);
    const [paciente, setPaciente] = useState({});
    const usuario = getUsuario();
    const history = useHistory()
    useEffect(() => {
        obterAgendamentos()
    }, [])

    useInterval(() => {
        obterAgendamentos()
    }, 10000)

    const obterAgendamentos = () => {
        Promise.resolve(get(`/atendimento/agendaemespera/${usuario?.id}`)).then(obj => {
            setAgendamentos(obj)
        })
    }

    const chamarPainel = (item) => {
        setPaciente(item);
        setAbrirModalPainel(true);
    }

    const validarIniciarAtendimento = (objAgenda) => {

        if (objAgenda.pres_id == usuario.prestador_id) {
            history.push({ pathname: '/atendimento/prontuario/cadastro', state: { paciente: objAgenda.paciente_id, agenda: objAgenda.id } })
        } else {
            mostrarToast('erro', 'Usuário não está ligado ao prestador')
        }

    }

    return (
        <>
            <div>
                <div className='mb-3'>
                    <h2>Sala de Espera</h2>
                </div>
                <div className='row'>
                    {agendamentos.map(x => {
                        return <div className='col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-30'>
                            <div class="card">
                                <div className='card-header'>
                                    <div className="row-space-between">
                                        <div className="flex-column vertical-center">
                                            <h5>{x.hora_inicial + (x.hora_final ? ' - ' + x.hora_final : '')}</h5>
                                        </div>
                                        <div>
                                            <BtnAcao classTooltip={'tooltip-input-modal'} classeContent="ml-1-between" className='mr-1' icone="icon-Megaphone" texto="Chamar no Painel" action={_ => chamarPainel(x)} />
                                            {/* <Link to={{ pathname: '/atendimento/prontuario/cadastro', state: { paciente: x.paciente_id, agenda: x.id } }}> */}
                                            <BtnAcao classTooltip={'tooltip-input-modal'} classeContent="ml-1-between" icone="icon-File-ClipboardFileText" texto="Prontuário" action={_ => { validarIniciarAtendimento(x) }} />
                                            {/* </Link> */}
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div className="limitador-caracteres class-teste">
                                        <h5>
                                            <b>
                                                {x.paciente}
                                            </b>
                                        </h5>
                                    </div>
                                    <div className="class-teste flex-column">
                                        <p><b>Horário de Chegada: </b> {x.hora_chegada}</p>
                                        <p><b>Prestador: </b> {x.prestador}</p>
                                        <p><b>Data Agendamento: </b> {x.data}</p>
                                    </div>
                                </div>
                                <div className='card-footer'>
                                    <p class="card-text"><b>Observação:</b></p>
                                    <p class="card-text">{x.observacao}</p>
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            </div>
            <ChamarPainel item={paciente} setShowModal={setAbrirModalPainel} showModal={abrirModalPainel} aposSubmit={obterAgendamentos} />
        </>
    )
}

export default Consulta